<template>
  <graphql-requester
    :gql="$options.GET_SAMEDAY_AVAILABILITY"
    v-slot="{ data, loading, gqlRequest }"
    :variables="variables"
    :has-input="false"
    @result="onResult"
  >
    <sameday-loading v-if="loading" :params="params" />
    <slot v-else-if="data && !loading" v-bind="{ services }"></slot>
    <sameday-error v-else :params="params" @on:retry="gqlRequest" />
  </graphql-requester>
</template>

<script>
import { GET_SAMEDAY_AVAILABILITY } from "@/graphql";
import GraphqlRequester from "@/components/GraphqlRequester.vue";
import SamedayLoading from "@/components/Sameday/SamedayItemLoading.vue";
import SamedayError from "@/components/Sameday/SamedayItemError.vue";

export default {
  GET_SAMEDAY_AVAILABILITY,
  components: {
    GraphqlRequester,
    SamedayLoading,
    SamedayError,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    variables() {
      let input = {};
      input.location_id = this.params?.location_id;
      input.location_id = parseInt(input.location_id, 10);
      return input;
    },
  },
  methods: {
    onResult(data) {
      this.services = data?.getSameDayAvailability || [];
      this.$emit("on:loaded");
    },
  },
};
</script>
